module.exports = __webpack_public_path__ + "static/img/the-mca-vis-bg.3453130.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/the-mca-vis-bg.jpg
// module id = WWS7
// module chunks = 1